import React, { useContext } from "react";
import { Text, View } from "@/styles/reactnative";
import { useWindowDimensions } from "@app/hooks";
import { useTranslation } from "react-i18next";
import { ThemeContext } from "@/theme/ThemeProvider";
import {MobileCalVW, useIsMobile} from "@utils/CalVW.tsx";
import { formatDecimal4Truncate } from "@/utils/formatDecimal";
import { useNavigate } from "react-router-dom";

const HeaderBottomLists = ({ item, index }) => {
  const { borderColor } = useContext(ThemeContext).theme.COLORS;
  const { width } = useWindowDimensions();
  const { t } = useTranslation();
  const isMobile = useIsMobile();
  const navigate = useNavigate();

  const handleClick = () => {
    if (item?.isClickable && item?.title === 'todayPnl') {
      navigate('/pnl-calendar');
    }
  };

  return (
    <View
      style={{
        alignItems: "flex-start",
        width: "100%",
        paddingBottom: width < 1100 ? 10 : 0,
        marginBottom: width < 1100 ? 10 : 0,
        cursor: item?.isClickable ? 'pointer' : 'default',
      }}
      onClick={handleClick}
    >
      <Text size={20}>{t(item?.title)}</Text>
      <Text
        size={30}
        style={{
          marginRight: 10,
          fontWeight: "500",
          marginTop: isMobile ? MobileCalVW(24) : 20,
          color: item?.title === 'todayPnl' && parseFloat(item?.usd) > 0 ? '#00C853' : 
                item?.title === 'todayPnl' && parseFloat(item?.usd) < 0 ? '#FF1744' : undefined
        }}
      >
       {item?.title === 'todayPnl' && parseFloat(item?.usd) > 0 ? '+' : ''}{formatDecimal4Truncate(item?.usd)} USDT
      </Text>
      <Text size={15} style={{marginTop: isMobile ? MobileCalVW(13) : 10}}>
        ≈{formatDecimal4Truncate(item?.currencyValue?.toFixed(4))} {item?.currency}
      </Text>
      {item?.title === 'todayPnl' && (
        <Text 
          size={12} 
          style={{
            marginTop: isMobile ? MobileCalVW(8) : 6,
            color: '#888',
            fontStyle: 'italic'
          }}
        >
          {t('clickToViewPnlCalendar')}
        </Text>
      )}
    </View>
  );
};

export default React.memo(HeaderBottomLists);
